import React, { useEffect, useState } from "react";
import styles from "../styles/regularmealstatus.module.css";
import { getFetch } from "../../../../../fetch/fetch";
import { koreanLocationToEnglish } from "../../../../../data/locationFuntion";

const howManyDays = 30;

// sunbae + bundangsunbae 에서 needRegularMeal true 인 지점들만
const LOCATION_COLUMNS = [
  { key: "gangnam", label: "강남 1호점" },
  { key: "gangnam2", label: "강남 2호점" },
  { key: "daechi", label: "대치 2층" },
  { key: "daechi2", label: "대치 3층" },
  { key: "daechi3", label: "대치 6층" },
  { key: "songpa", label: "송파점" },
  { key: "gimpo", label: "김포점" },
  { key: "sinchon", label: "신촌점" },
  { key: "bundang", label: "분당점" },
  { key: "gangdong", label: "강동점" },
  { key: "hanam", label: "하남점" },
  { key: "daegu", label: "대구점" },
  { key: "centum", label: "센텀점" },
  { key: "dongtan", label: "동탄점" },
];

const RegularMealTable: React.FC<any> = (props) => {
  const [rows1, setRows1] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (props.rows1) {
      setRows1(props.rows1);
      return;
    }
    start();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.rows1]);

  const start = async () => {
    const newDateArray: any[] = [];
    const startDate = new Date();
    startDate.setDate(startDate.getDate() + 6);

    for (var i = 0; i < howManyDays * 2; i++) {
      const startDateString =
        startDate.getFullYear() * 10000 +
        (startDate.getMonth() + 1) * 100 +
        startDate.getDate();

      const whenType = i % 2 === 0 ? "lunch" : "dinner";
      const oneRow: any = {};
      oneRow.whenType = whenType;
      oneRow.id = startDateString;

      newDateArray.push(oneRow);

      if (i % 2 === 1) startDate.setDate(startDate.getDate() - 1);
    }

    const data = await getTotalData();

    const rows: any[] = [];

    newDateArray.forEach((date: any) => {
      const oneRow: any = {};
      oneRow.id = date.id;
      oneRow.whenType = date.whenType;
      oneRow.date = dateNumberToString(date.id, date.whenType);

      // 컬럼 초기화
      LOCATION_COLUMNS.forEach((col) => {
        oneRow[col.key] = [];
      });

      data?.forEach((element: any) => {
        if (element.isManualSubtract) return;

        const englishLocation = koreanLocationToEnglish(element.location);
        if (!englishLocation) return;

        // 이번 테이블에서 보여줄 지점만
        const isIncluded = LOCATION_COLUMNS.some((c) => c.key === englishLocation);
        if (!isIncluded) return;

        if (element.targetDateString === date.id && element.whenType === date.whenType) {
          oneRow[englishLocation].push(element);
        }
      });

      rows.push(oneRow);
    });

    setRows1(rows);
  };

  const dateNumberToString = (dateNumber: number, whenType: string) => {
    // 20210701 -> 7/1 (월요일)
    const year = Math.floor(dateNumber / 10000);
    const month = Math.floor((dateNumber % 10000) / 100);
    const date = dateNumber % 100;

    const day = new Date(year, month - 1, date).getDay();
    const dayString = ["일", "월", "화", "수", "목", "금", "토"][day];

    return `${month}/${date} (${dayString}) - ${whenType === "lunch" ? "점심" : "저녁"}`;
  };

  const getTotalData = async () => {
    try {
      setLoading(true);

      const result: any = await getFetch(
        `/dashboard/restaurant/regularmeal/total?howManyDays=${howManyDays}`
      );

      if (result.message === "success") {
        const data = result.data;

        data.forEach((element: any) => {
          const targetDate = new Date(element.targetDate);
          const targetDateString =
            targetDate.getFullYear() * 10000 +
            (targetDate.getMonth() + 1) * 100 +
            targetDate.getDate();

          element.targetDateString = targetDateString;
        });

        setLoading(false);
        return data;
      }

      setLoading(false);
    } catch (e) {
      console.warn(e);
      setLoading(false);
    }
  };

  const getCount = (row: any, key: string) => {
    return row?.[key] ? row[key].length : 0;
  };

  const getTotalCount = (row: any) => {
    return LOCATION_COLUMNS.reduce((sum, col) => sum + getCount(row, col.key), 0);
  };

  return (
    <div>
      <div className={`${styles.container} ${props.rows1 ? styles.noMargin : ""}`}>
        <table className={styles.table}>
          <colgroup>
            <col style={{ width: "150px" }} />
            {/* 나머지 컬럼은 전부 80px로 (지점 9개 + 총합 1개 = 10개) */}
            {Array.from({ length: LOCATION_COLUMNS.length + 1 }, () => {
              return <col style={{ width: "80px" }} />;
            })}
          </colgroup>

          <thead>
            <tr>
              <th colSpan={1 + LOCATION_COLUMNS.length + 1}>정기식 신청 현황</th>
            </tr>

            <tr>
              <th rowSpan={2}>날짜</th>

              <th colSpan={2}>강남점</th>
              <th colSpan={3}>대치점</th>

              <th rowSpan={2}>송파점</th>
              <th rowSpan={2}>김포점</th>
              <th rowSpan={2}>신촌점</th>
              <th rowSpan={2}>분당점</th>
              <th rowSpan={2}>강동점</th>
              <th rowSpan={2}>하남점</th>
              <th rowSpan={2}>대구점</th>
              <th rowSpan={2}>센텀점</th>
              <th rowSpan={2}>동탄점</th>

              <th rowSpan={2}>총 합계</th>
            </tr>

            <tr>
              <th>1호점</th>
              <th>2호점</th>

              <th>2층</th>
              <th>3층</th>
              <th>6층</th>
            </tr>
          </thead>

          {/* 로딩 */}
          {props.loading &&
            rows1.map((row: any) => {
              if (props.filter) {
                if (props.filterId !== row.id) return null;
              }

              return (
                <tr key={row.id + row.whenType} className={styles.oneRow}>
                  <td style={{ fontFamily: "Apple_SB" }}>-</td>

                  {/* 지점 9개 */}
                  {LOCATION_COLUMNS.map((col, idx) => (
                    <td
                      key={col.key}
                      style={
                        // 기존처럼 일부 컬럼만 파란색 주고 싶으면 여기서 조건 걸면 됨
                        idx === 0 || idx === 5 ? { color: "blue" } : undefined
                      }
                    >
                      -
                    </td>
                  ))}

                  {/* 총합 */}
                  <td style={{ color: "blue", fontFamily: "Apple_B", fontSize: "17px" }}>-</td>
                </tr>
              );
            })}

          {/* 데이터 */}
          {!props.loading &&
            rows1.map((row: any) => {
              if (props.filter) {
                if (props.filterId !== row.id) return null;
              }

              return (
                <tr key={row.id + row.whenType} className={styles.oneRow}>
                  <td style={{ fontFamily: "Apple_SB" }}>{row.date}</td>

                  {/* 지점 9개 */}
                  {LOCATION_COLUMNS.map((col) => (
                    <td key={col.key}>{getCount(row, col.key)}</td>
                  ))}

                  {/* 총합 */}
                  <td style={{ color: "blue", fontFamily: "Apple_B", fontSize: "17px" }}>
                    {getTotalCount(row)}
                  </td>
                </tr>
              );
            })}
        </table>

        {/* 필요하면 로컬 loading도 사용 가능 */}
        {/* {loading && <div>loading...</div>} */}
      </div>
    </div>
  );
};

export default RegularMealTable;